import { Route } from '@angular/router';
import { NotificationComponent } from './feature/notification/notification.component';
import { ContentSplitViewLayoutComponent } from '@kempower-nx-workspace/layout-templates';
import { NotificationsMenuComponent } from './feature/notifications-menu/notifications-menu.component';
import { PageExistsGuard } from '@kempower-nx-workspace/chargeye-shared';
import { NotificationDataService } from './data-access/notification-data/notification-data.service';

export const notificationsRoutes: Route[] = [
    {
        path: '',
        redirectTo: '/notifications/inbox',
        pathMatch: 'full',
    },
    {
        path: ':notificationStatus',
        canActivate: [PageExistsGuard],
        data: {
            pathParam: 'notificationStatus',
            pageExistGuardAllowedPages: NotificationDataService.getAvailableNotificationStatusUrls(),
            pageExistGuardRedirectTo: '/notifications/inbox',
        },
        providers: [PageExistsGuard],
        component: ContentSplitViewLayoutComponent,
        children: [
            {
                path: '',
                outlet: 'splitViewMenu',
                component: NotificationsMenuComponent,
            },
            {
                path: ':notificationId',
                component: NotificationComponent,
            },
        ],
    },
];
